export default __webpack_public_path__ + "static/media/rupee.1e31f6d6.svg";